import AdjustIcon from "../images/AdjustIcon.mjs";

/**
 * Simulation status: setup parameters
 * @see {GlyphIcon}
 * @see {AdjustIcon}
 */
const AppSimStatusSettingsIcon = class extends AdjustIcon {};

export default AppSimStatusSettingsIcon;